<ng-container *ngIf="insight$ | async as insight">
    <div articleInsightView [insight]="insight" (onError)="handleError($event)" class="h100 oa"></div>
</ng-container>